import { ACTIONS_FROM_SM } from '../../constants.js';

export function noAvailableData(frameNA, timeNA, supervisorPassNA, descriptionNA) {
  return {
    type: ACTIONS_FROM_SM.NO_AVAILABLE_INFO,
    frame: frameNA,
    time: timeNA,
    supervisorPass: supervisorPassNA,
    description: descriptionNA
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_no_available.js